export const COMPLETE_NEW_ORG_SUBMIT = 'COMPLETE_NEW_ORG_SUBMIT';
export const COMPLETE_ORG_NAME_CHECK = 'COMPLETE_ORG_NAME_CHECK';
export const NEW_ORG_SUBMIT_FAILED = 'NEW_ORG_SUBMIT_FAILED';
export const REQUEST_ORG_NAME_CHECK = 'REQUEST_ORG_NAME_CHECK';
export const RESET_ORG_CREATE_STATE = 'RESET_ORG_CREATE_STATE';
export const SUBMIT_NEW_ORG = 'SUBMIT_NEW_ORG';
export const UPDATE_ORG_NAME = 'UPDATE_ORG_NAME';
export const UPDATE_ORG_PROGRAM = 'UPDATE_ORG_PROGRAM';
export const UPDATE_ORG_SFDC = 'UPDATE_ORG_SFDC';
